import FilterAnnotModalContainer from './FilterAnnotModalContainer';

export default FilterAnnotModalContainer;